import { render, staticRenderFns } from "./TelephoneInputLazy.vue?vue&type=template&id=71641ad8&scoped=true"
import script from "./TelephoneInputLazy.vue?vue&type=script&lang=js"
export * from "./TelephoneInputLazy.vue?vue&type=script&lang=js"
import style0 from "./TelephoneInputLazy.vue?vue&type=style&index=0&id=71641ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71641ad8",
  null
  
)

export default component.exports